/** IoT Query + Commands (gateway-local). Paths mirror the gateway control/query routes (D-049 kind addressing). */
export const iotEndpoints = {
  // grow room (parent)
  growRoomActuators: (room: string) => `/v1/iot/grow-rooms/${room}/actuators`,
  growRoomActuator: (room: string, act: string) => `/v1/iot/grow-rooms/${room}/actuators/${act}`,
  growRoomSensors: (room: string) => `/v1/iot/grow-rooms/${room}/sensors`,
  growRoomSensor: (room: string, s: string) => `/v1/iot/grow-rooms/${room}/sensors/${s}`,
  growRoomCommand: (room: string, act: string) => `/v1/iot/grow-rooms/${room}/actuators/${act}/commands`,
  // grow room rack (child of a grow room)
  growRoomRackActuators: (room: string, rack: string) => `/v1/iot/grow-rooms/${room}/racks/${rack}/actuators`,
  growRoomRackActuator: (room: string, rack: string, act: string) =>
    `/v1/iot/grow-rooms/${room}/racks/${rack}/actuators/${act}`,
  growRoomRackSensors: (room: string, rack: string) => `/v1/iot/grow-rooms/${room}/racks/${rack}/sensors`,
  growRoomRackSensor: (room: string, rack: string, s: string) =>
    `/v1/iot/grow-rooms/${room}/racks/${rack}/sensors/${s}`,
  growRoomRackCommand: (room: string, rack: string, act: string) =>
    `/v1/iot/grow-rooms/${room}/racks/${rack}/actuators/${act}/commands`,
  // plumbing room (parent)
  plumbingRoomActuators: (room: string) => `/v1/iot/plumbing-rooms/${room}/actuators`,
  plumbingRoomActuator: (room: string, act: string) => `/v1/iot/plumbing-rooms/${room}/actuators/${act}`,
  plumbingRoomSensors: (room: string) => `/v1/iot/plumbing-rooms/${room}/sensors`,
  plumbingRoomSensor: (room: string, s: string) => `/v1/iot/plumbing-rooms/${room}/sensors/${s}`,
  plumbingRoomCommand: (room: string, act: string) =>
    `/v1/iot/plumbing-rooms/${room}/actuators/${act}/commands`,
  // plumbing room node (child of a plumbing room)
  plumbingRoomNodeActuators: (room: string, node: string) =>
    `/v1/iot/plumbing-rooms/${room}/nodes/${node}/actuators`,
  plumbingRoomNodeActuator: (room: string, node: string, act: string) =>
    `/v1/iot/plumbing-rooms/${room}/nodes/${node}/actuators/${act}`,
  plumbingRoomNodeSensors: (room: string, node: string) =>
    `/v1/iot/plumbing-rooms/${room}/nodes/${node}/sensors`,
  plumbingRoomNodeSensor: (room: string, node: string, s: string) =>
    `/v1/iot/plumbing-rooms/${room}/nodes/${node}/sensors/${s}`,
  plumbingRoomNodeCommand: (room: string, node: string, act: string) =>
    `/v1/iot/plumbing-rooms/${room}/nodes/${node}/actuators/${act}/commands`,
} as const;
